export default class Martyr
{
    constructor(sacrificer_code, personal_info, istshhad_info, beneficial_info, lands, cash_allowance, construction_grant){
        this.sacrificer_code = sacrificer_code
        this.personal_info = personal_info
        this.istshhad_info = istshhad_info
        this.beneficial_info = beneficial_info
        this.lands = lands
        this.cash_allowance = cash_allowance
        this.construction_grant = construction_grant
    }

    toFormData(){
        let fData = new FormData()
        
        //personal information for injury.
        // fData.append('name1', this.personal_info.name1);
        // fData.append('name2', this.personal_info.name2);
        // fData.append('name3', this.personal_info.name3);
        // fData.append('name4', this.personal_info.name4);
        // fData.append('family_name', this.personal_info.family_name);
        // fData.append('mother_name', this.personal_info.mother_name);

        fData.append('sacrificer_code', this.sacrificer_code);
        fData.append('birth_date', this.personal_info.birth_date);
        fData.append('marital_status_id', this.personal_info.marital_status_id);
        fData.append('certificate_id', this.personal_info.certificate_id);
        fData.append('number_children', this.personal_info.number_children);
        fData.append('religion_id', this.personal_info.religion_id);
        fData.append('nationalism_id', this.personal_info.nationalism_id);
        fData.append('father_alive', this.personal_info.father_alive);
        fData.append('mother_alive', this.personal_info.mother_alive);
        fData.append('retirement_number', this.personal_info.retirement_number);

        //injury info.
        fData.append('date_marty', this.istshhad_info.date_marty);
        fData.append('place_marty', this.istshhad_info.place_marty);
        fData.append('dept', this.istshhad_info.dept);

        //attachment info.
        if(typeof this.istshhad_info.attachment_info == 'object')
            fData.append('attachment_info', this.istshhad_info.attachment_info);
        fData.append('attachment_qssam', this.istshhad_info.attachment_qssam);

        // lands.
        this.beneficial_info.fields.forEach((el, i)=>{
            fData.append('beneficiaries['+i+'][relative_relation_id]', el.relative_relation_id);
            fData.append('beneficiaries['+i+'][name1]', el.name1);
            fData.append('beneficiaries['+i+'][name2]', el.name2);
            fData.append('beneficiaries['+i+'][name3]', el.name3);
            fData.append('beneficiaries['+i+'][name4]', el.name4);
            fData.append('beneficiaries['+i+'][family_name]', el.family_name);
            fData.append('beneficiaries['+i+'][mother_name]', el.mother_name);
            fData.append('beneficiaries['+i+'][birth_date]', el.birth_date);
            fData.append('beneficiaries['+i+'][specialization]', el.specialization);
            fData.append('beneficiaries['+i+'][phone1]', el.phone1);
            fData.append('beneficiaries['+i+'][phone2]', el.phone2);
            fData.append('beneficiaries['+i+'][gender_id]', el.gender_id);
            fData.append('beneficiaries['+i+'][marital_status_id]', el.marital_status_id);
            fData.append('beneficiaries['+i+'][certificate_id]', el.certificate_id);
            if(el.id_type == '1'){
                fData.append('beneficiaries['+i+'][nationality_number]', el.nationality_number);
            }else{
                fData.append('beneficiaries['+i+'][national_id_number]', el.national_id_number);
            }

            fData.append('beneficiaries['+i+'][region]', el.region);
            fData.append('beneficiaries['+i+'][nearest_point]', el.nearest_point);
            fData.append('beneficiaries['+i+'][mahla]', el.mahla);
            fData.append('beneficiaries['+i+'][zqaq]', el.zqaq);
            fData.append('beneficiaries['+i+'][dar]', el.dar);
            fData.append('beneficiaries['+i+'][accommodation_id]', el.accommodation_id);
            fData.append('beneficiaries['+i+'][city_id]', el.city_id);

            fData.append('beneficiaries['+i+'][attachment]', el.attachment_beneficiary);

            // lands.
            this.lands.fields.filter((x)=>x.beneficiary_id == (i+1)).forEach((land, ii)=>{
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][grant_name]', land.grant_name);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][section_number]', land.section_number);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][accommodation_id]', land.accommodation_id);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][area_section]', land.area_section);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][city_id]', land.city_id);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][district]', land.district);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][sub_district]', land.sub_district);
                fData.append('beneficiaries['+i+'][earthSections]['+ii+'][attachment]', land.attachment_lands);

                alert(land);
            });

            // cash allowance.
            this.cash_allowance.fields.filter((x)=>x.beneficiary_id == (i+1)).forEach((cash, ii)=>{
                fData.append('beneficiaries['+i+'][moneysReplace]['+ii+'][grant_name]', cash.grant_name);
                fData.append('beneficiaries['+i+'][moneysReplace]['+ii+'][received_date]', cash.received_date);
                fData.append('beneficiaries['+i+'][moneysReplace]['+ii+'][ammont]', cash.ammont);
                fData.append('beneficiaries['+i+'][moneysReplace]['+ii+'][attachment]', cash.attachment_cash);
            });

            // construction grant.
            this.construction_grant.fields.filter((x)=>x.beneficiary_id == (i+1)).forEach((grant, ii)=>{
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][grant_name]', grant.grant_name);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][section_number]', grant.section_number);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][accommodation_id]', grant.accommodation_id);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][area_section]', grant.area_section);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][city_id]', grant.city_id);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][district]', grant.district);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][sub_district]', grant.sub_district);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][grant_name]', grant.grant_name);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][received_date]', grant.received_date);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][ammont]', grant.ammont);
                fData.append('beneficiaries['+i+'][buildsReplace]['+ii+'][attachment]', grant.attachment_grant);
            });

        });
        return fData
    }
}

